.normal {
  height: 40px;
  width: 40px;
  border-radius: 20px;
}

.large {
  height: 56px;
  width: 56px;
  border-radius: 28px;
}

.squareish {
  border-radius: 4px;
}

/* StackedProviderImage — higher specificity than .image-overlay-wrapper to ensure correct order in production bundles */
div .stacked-logo-wrapper {
  flex-direction: row-reverse;
  justify-content: end;
  align-items: flex-start;
  pointer-events: none;
  padding: 8px;
}

.stacked-logo {
  --size: var(--logo-size, 12%);
  width: var(--size);
  aspect-ratio: 1;
  border-radius: 50rem;
  &:not(:only-child) {
    margin-left: calc(var(--size) / 5 * -1);
  }
}

.stacked-logo-portrait {
  --logo-size: 18%;
}
